
const compareNowWith = time => Date.now() - time;

const timeFromString = string => new Date(string).getTime();

// Note: the the property 'live' means the forum thread is, will be or has been live at some point

export const isLiveNow = forumThread => forumThread.live && compareNowWith(timeFromString(forumThread.liveStart)) > 0 && compareNowWith(timeFromString(forumThread.liveEnd)) < 0;

export const isSoonToBeLive = forumThread => forumThread.live && compareNowWith(timeFromString(forumThread.liveStart)) < 0;

export const hasEnded = forumThread => forumThread.live && compareNowWith(timeFromString(forumThread.liveEnd)) >= 0;



/** WEBPACK FOOTER **
 ** ./src/members/__shared__/forumLiveStatus.js
 **/